import { useState } from "react";
import { Quote, Star } from "lucide-react";
import { fallbackTestimonials } from "@/constants/fallbackData";

export default function Testimonials() {
  const [items] = useState(fallbackTestimonials);

  return (
    <section
      id="voices"
      data-testid="testimonials-section"
      className="relative py-20 md:py-32 overflow-hidden"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="overline">Voices</span>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl md:text-6xl leading-[1.05] tracking-tight">
            Little returns to
            <span className="italic text-[#C05C46]"> alright.</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-[#5C6B5D]">
            The best proof of Ayurveda is a quiet, ordinary Tuesday that feels
            good again. Here are a few.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8">
          {items.map((t, idx) => (
            <figure
              key={t.id}
              data-testid={`testimonial-${idx}`}
              className={`relative bg-[#EBE4D8] border border-[#DCD3C6] rounded-3xl p-8 md:p-10 ${
                idx % 2 === 1 ? "md:translate-y-8" : ""
              }`}
            >
              <Quote
                className="h-8 w-8 text-[#C05C46]/70"
                strokeWidth={1.25}
              />
              <blockquote className="mt-6 font-serif-display text-2xl md:text-3xl leading-snug text-[#2E3A2F]">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between">
                <div>
                  <div className="font-medium text-[#2E3A2F]">{t.name}</div>
                  <div className="overline mt-1">
                    {t.location} · {t.concern}
                  </div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: t.rating }).map((_, i) => (
                    <Star
                      key={i}
                      className="h-4 w-4 fill-[#E08933] text-[#E08933]"
                      strokeWidth={1}
                    />
                  ))}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
